import { Amplify } from 'aws-amplify';

// These values are injected at build time from CDK stack outputs.
// For local development, copy .env.example to .env.local and fill in values.
const config = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID ?? '',
      allowGuestAccess: true,
    },
  },
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_APPSYNC_ENDPOINT ?? '',
      region: import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
      defaultAuthMode: 'identityPool' as const,
    },
  },
};

export function configureAmplify() {
  Amplify.configure(config);
}
